import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    container: {
      justifyContent: "start",
      display: "flex",
      flexDirection: "column",
    },
    name: {
      color: theme.gray400,
      fontSize: 14,
      lineHeight: theme.spacing(8),
    },
    value: {
      color: theme.gray800,
      fontSize: 16,
      lineHeight: theme.spacing(10),
    },
  }),
);

export const ItemDetails = ({
  name,
  value,
  "data-test-id": dataTestId,
  "data-hj-suppress": dataHjSuppress,
}: {
  name: React.ReactNode;
  value: React.ReactNode;
  "data-test-id"?: string;
  "data-hj-suppress"?: boolean;
}) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <span
        data-test-id={dataTestId ? `${dataTestId}-${name}` : ""}
        className={classes.name}
      >
        {name}
      </span>
      <span
        className={classes.value}
        data-test-id={dataTestId ? `${dataTestId}-value` : ""}
        data-hj-suppress={dataHjSuppress}
      >
        {value}
      </span>
    </div>
  );
};
